import { Injectable } from '@angular/core'
import { CaStateService } from '../../../core/services/ca-state.service'
import { Command, CommandCategory } from '../command.model'
import { CommandRegistryService } from './command-registry.service'

// MVP scope: paleta neduplikuje levé hamburger menu (žádná "Navigate" kategorie).
// Registruje pouze Vytvoř akce a Admin sub-pages. Admin sekci filtruje paleta
// at-render-time podle AuthContextStorageService.isUserAdmin().
//
// TODO: revize Admin položek na ty nejdůležitější — dohodnuto s Lukášem,
// zatím Uživatelé / Projekty / Ruční spouštění procesů.
//
// TODO: per-feature module registrace přijde s DEV-350 Architecture Modernization.
@Injectable({ providedIn: 'root' })
export class NavigationCommandsService {

    private registered = false

    constructor(
        private readonly registry: CommandRegistryService,
        private readonly caState: CaStateService
    ) {}

    public registerAll(): void {
        if (this.registered) {
            return
        }
        this.registered = true

        const commands: Array<Command> = [
            // Vytvořit — priority (V2 refinement: vytvářecí akce nahoře)
            {
                id: 'create.contract',
                title: 'Vytvořit pachtovní smlouvu',
                category: CommandCategory.Create,
                icon: 'fa-plus',
                keywords: ['nová', 'pacht'],
                action: () => this.caState.setContractCreateState()
            },
            {
                id: 'create.subcontract',
                title: 'Vytvořit podpachtovní smlouvu',
                category: CommandCategory.Create,
                icon: 'fa-plus',
                keywords: ['nová', 'podpacht'],
                action: () => this.caState.setSubcontractCreateState()
            },
            {
                id: 'create.subject',
                title: 'Vytvořit osobu',
                category: CommandCategory.Create,
                icon: 'fa-plus',
                keywords: ['nový', 'subjekt', 'pronajímatel'],
                action: () => this.caState.setSubjectShowCreate()
            },
            {
                id: 'create.barter',
                title: 'Vytvořit směnu užívání',
                category: CommandCategory.Create,
                icon: 'fa-plus',
                keywords: ['barter'],
                action: () => this.caState.setBarterCreateState()
            },
            {
                id: 'create.nonCadastralContract',
                title: 'Vytvořit smlouvu mimo data katastru',
                category: CommandCategory.Create,
                icon: 'fa-plus',
                keywords: ['mimo katastr', 'ne-katastrální'],
                action: () => this.caState.setNonCadastralContractCreateState()
            },

            // Administrace — viditelné jen pro admin uživatele (filtr v palette komponentě)
            {
                id: 'admin.users',
                title: 'Uživatelé',
                category: CommandCategory.Admin,
                icon: 'fa-user-o',
                keywords: ['účty'],
                action: () => this.caState.setAdminUserListState()
            },
            {
                id: 'admin.projects',
                title: 'Projekty',
                category: CommandCategory.Admin,
                icon: 'fa-folder-open-o',
                keywords: ['klienti'],
                action: () => this.caState.setProjectListState()
            },
            {
                id: 'admin.triggerProcess',
                title: 'Ruční spouštění procesů',
                category: CommandCategory.Admin,
                icon: 'fa-cogs',
                keywords: ['proces', 'spustit', 'admin job'],
                action: () => this.caState.setTriggerProcessState()
            }
        ]

        this.registry.register(commands)
    }
}